import { useCallback } from 'react';

const { REACT_APP_FOTBOLLPLAY_API_BASE_URL } = process.env;

export const useFotbollPlayVideo = () => {
  const fetchVideoData = useCallback(
    async (videoId: string, league: string): Promise<any | null> => {
      let data: null;

      try {
        const url = `${REACT_APP_FOTBOLLPLAY_API_BASE_URL}/${league}/playlist/${videoId}`;
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Fetch video failed! (${response.status})`);
        }

        data = await response.json();
      } catch (error) {
        console.error(error);
        throw error;
      }

      return data;
    },
    []
  );

  return {
    fetchVideoData,
  };
};
